import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-tooltip-dialog',
    templateUrl: './tooltip-dialog.component.html',
    styleUrls: ['./tooltip-dialog.component.scss']
})
export class TooltipDialogComponent implements OnInit {
    @Output() leaveIt: EventEmitter<boolean> = new EventEmitter();
    @Output() confirm: EventEmitter<boolean> = new EventEmitter();
    showtime: boolean;
    constructorTime: number;

    constructor() {
        const time = new Date();
        this.constructorTime = time.getTime();
    }

    ngOnInit() {
        setTimeout(() => {
            this.showtime = true;
        }, 10);
    }

    action(what) {
        this.showtime = false;
        setTimeout(() => {
            if (what === 'leaveIt') {
                this.leaveIt.emit(true);
            } else {
                this.confirm.emit(true);
            }
        }, 150);
    }

    clickOutsideAction(what) {
        const time = new Date();
        const getTime = time.getTime();
        if ((getTime - this.constructorTime) > 500) {
            this.action(what);
        }
    }

}
